import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import NPCModel from "../../scenario/NPCModel";
import ChatMessage from "../model/ChatMessage";

export default class ChatMessageMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NPCModel} npcModel 
     */
    constructor(target, dispatcher, npcModel) {
        super(target, dispatcher);

        this._npcModel = npcModel;

        /** @type {ChatMessage} */
        this._model = this.getCustomData().chatMessage;
        this._npc = this._npcModel.getNpcByNpcID(this._model.npcId);
    }

    initialize() {
        super.initialize();

        this._slice9Panel = new Slice9Panel(this._target, this._target.children.find(c => c instanceof createjs.Bitmap), { mode: Slice9Panel.VERTICAL });
        this._target.contentTextField.text = this._model.content.getText().trim();

        if (this._target.nameTextField && this._npc) {
            this._target.nameTextField.text = (this._npc.getName() || this._npc.getNickname()).trim();
        }

        const minHeight = this._target.contentTextField.getBounds().height + 16;
        this._slice9Panel.setMinHeight(minHeight);
    }

    get skin() {
        return this._target;
    }

    get model() {
        return this._model;
    }
}